import { type TGenre } from './genre'

/**
 * An audio carries its genres as flat `<parent>--<sub>` slugs, and the details screen prints two rows
 * from that one list: the distinct parents and the distinct subgenres. A parent with no `parentTitle`
 * falls back to its slug, and a subgenre keeps the parent it belongs to so its URL can be built.
 * Ported from audio-web `processGenres` / `processSubgenres`.
 */
export const splitAudioGenres = (genres: TGenre[]): { genres: TGenre[]; subgenres: TGenre[] } => {
    const parents = new Map<string, TGenre>()
    const subgenres = new Map<string, TGenre>()

    genres.forEach(genre => {
        const [parentSlug, subSlug] = genre.slug.split('--')

        if (parentSlug && !parents.has(parentSlug)) {
            parents.set(parentSlug, {
                ...genre,
                title: genre.parentTitle || parentSlug || genre.title,
                slug: parentSlug,
            })
        }

        if (subSlug) {
            const fullSlug = `${parentSlug || ''}--${subSlug}`

            if (!subgenres.has(fullSlug)) {
                subgenres.set(fullSlug, {
                    ...genre,
                    slug: fullSlug,
                    parentTitle: genre.parentTitle || parentSlug || undefined,
                })
            }
        }
    })

    return { genres: [...parents.values()], subgenres: [...subgenres.values()] }
}
